import { render } from "./HoverPopUp.vue?vue&type=template&id=2f08c2e1&scoped=true"
import script from "./HoverPopUp.vue?vue&type=script&lang=js"
export * from "./HoverPopUp.vue?vue&type=script&lang=js"

import "./HoverPopUp.vue?vue&type=style&index=0&id=2f08c2e1&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f08c2e1"]])

export default __exports__